// Re-export everything from the auth modules
export * from "./auth0-config";
export * from "./auth0-client";
export * from "./auth-context";

// Default export for easier imports
import { AuthProvider, AuthGuard, useAuth } from "./auth-context";

// Create a named object before exporting it as default
const authExports = { AuthProvider, AuthGuard, useAuth };
export default authExports;
